import React from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import {selectCompareIndicator} from "../../actions/indicators";
import LocaleUtils from "qwc2/utils/LocaleUtils";
import IndicatorUtils from "../../utils/IndicatorUtils";

class SingleIndicatorSelect extends React.Component {
    static propTypes = {
        compareIndicator: PropTypes.object,
        indicators: PropTypes.array,
        selectCompareIndicator: PropTypes.func,
        selectedObjectType: PropTypes.string,
    }
    static defaultProps = {}

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            isLoading: true,
            url: null,
        };
    }


    render() {
        const compareIndicatorId = this.props.compareIndicator?.indicator?.id || null;
        const newIndicators = [];
        const newTimes = [];
        this.props.indicators.forEach(i => {
            if (i.indicatorValueObjectTypes.indexOf(this.props.selectedObjectType) > -1) {
                newIndicators.push(i);
            }
            if (i.id == compareIndicatorId) {
                if (i.timeSlices) {
                    i.timeSlices.forEach(ts => newTimes.push(ts));
                }
            }
        });

        return (
            <div className="indicators-additionallist">
                <strong>{LocaleUtils.tr('indicators.compareindicator')}</strong>
                <div className="indicators-additionallist-add">
                    {this.renderIndicatorSelector(newIndicators)}
                    {this.renderTimeSelector(newTimes)}
                </div>
            </div>
        );
    }

    renderTimeSelector(newTimes) {
        if (newTimes.length == 0) {
            return null;
        }
        const value = this.props.compareIndicator?.time || '';
        return (
            <select value={value}
                    onChange={ev => this.selectTime(ev)}>
                {newTimes.map(item => {
                    return (
                        <option key={item}
                                value={item}>{IndicatorUtils.normalizeDate(item)}</option>
                    );
                })}
            </select>
        );
    }

    selectIndicator(ev) {
        let newIndi = null;
        let newTime = null;
        this.props.indicators.forEach(i => {
            if (i.id == ev.target.value) {
                newIndi = i;
                if (i.timeSlices && i.timeSlices[0]) {
                    newTime = i.timeSlices[0];
                }
            }
        });

        this.props.selectCompareIndicator({
            indicator: newIndi,
            time: '' + newTime
        });
    }

    renderIndicatorSelector(newIndicators) {
        const compareIndicatorId = this.props.compareIndicator?.indicator?.id || '';
        return (
            <select value={compareIndicatorId}
                    onChange={ev => this.selectIndicator(ev)}>
                <option key="-" value="">-</option>
                {newIndicators.map(item => {
                    return (
                        <option key={item.id}
                                value={item.id}>{item.name}</option>
                    );
                })}
            </select>
        );
    }

    selectTime(ev) {
        const compareIndicatorId = this.props.compareIndicator?.indicator?.id || '';
        this.props.indicators.forEach(i => {
            if (i.id == compareIndicatorId) {
                this.props.selectCompareIndicator({
                    indicator: i,
                    time: '' + ev.target.value
                });
            }
        });
    }
}

const selector = (state) => ({
    selectedObjectType: state.indicators.selectedObjectType,
    indicators: state.indicators.indicators,
    compareIndicator: state.indicators.compareIndicator,
});

export default connect(selector, {
    selectCompareIndicator: selectCompareIndicator,
})(SingleIndicatorSelect);
